import { ShopListByOne } from './ShopListByOne';

export {
  ShopListByOne,
};
